import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 导入所有组件
import Home from "./views/home/home";
import newslistVue from "./views/news/newslist.vue";
import newsdetailVue from "./views/news/newsdetail";
import newsmainVue from "./views/news/newsmain.vue";
import expertVue from "./views/expert/expert.vue";
import supplierlistVue from "./views/supplier/supplierlist.vue";
import supplierdetailVue from "./views/supplier/supplierdetail.vue";
import circlemainVue from "./views/circle/circlemain.vue";
import circletopicVue from "./views/circle/circletopic.vue";
import userVue from "./views/user/user.vue";
import searchmainVue from "./views/search/searchmain.vue";
import aboutVue from "./views/home/about.vue";
import resetVue from "./views/user/reset.vue";
import agreementVue from "./views/home/agreement.vue";
import mloginVue from "./views/user/mlogin.vue";
import demandmainVue from "./views/demand/demandmain.vue";
import demanddetailVue from "./views/demand/demanddetail.vue";
import applysupplierVue from "./views/supplier/applysupplier.vue";
import userlevelVue from "./views/user/userlevel.vue";
import paysuccessVue from "./views/user/paysuccess.vue";
import userrecordVue from "./views/user/userrecord.vue";
import productList from "./views/product/productList.vue";
import productDetail from "./views/product/productDetail.vue";
import productCustomize from "./views/product/productCustomize.vue";
import customizeList from "./views/product/customizeList.vue";
import demandDetails from "./views/product/demandDetails.vue";
import request from "./utils/request.js";
import { routesAddArea } from "./utils/formatRoutes.js";

let routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/newslist",
    name: "newslist",
    component: newslistVue,
  },
  {
    path: "/newsdetail",
    name: "newsdetail",
    component: newsdetailVue,
  },
  {
    path: "/newsmain",
    name: "newsmain",
    component: newsmainVue,
  },
  {
    path: "/expert",
    name: "expert",
    component: expertVue,
  },
  {
    path: "/supplierlist",
    name: "supplierlist",
    component: supplierlistVue,
  },
  {
    path: "/supplierdetail",
    name: "supplierdetail",
    component: supplierdetailVue,
  },
  {
    path: "/circlemain",
    name: "circlemain",
    component: circlemainVue,
  },
  {
    path: "/circletopic",
    name: "circletopic",
    component: circletopicVue,
  },
  {
    path: "/user",
    name: "user",
    component: userVue,
  },
  {
    path: "/searchmain",
    name: "searchmain",
    component: searchmainVue,
  },
  {
    path: "/about",
    name: "about",
    component: aboutVue,
  },
  {
    path: "/reset",
    name: "reset",
    component: resetVue,
  },
  {
    path: "/agreement",
    name: "agreement",
    component: agreementVue,
  },
  {
    path: "/mlogin",
    name: "mlogin",
    component: mloginVue,
  },
  {
    path: "/demandmain",
    name: "demandmain",
    component: demandmainVue,
  },
  {
    path: "/demanddetail",
    name: "demanddetail",
    component: demanddetailVue,
  },
  {
    path: "/applysupplier",
    name: "applysupplier",
    component: applysupplierVue,
  },
  {
    path: "/userlevel",
    name: "userlevel",
    component: userlevelVue,
  },
  {
    path: "/paysuccess",
    name: "paysuccess",
    component: paysuccessVue,
  },
  {
    path: "/userrecord",
    name: "userrecord",
    component: userrecordVue,
  },
  {
    path: "/productList",
    name: "productList",
    component: productList,
  },
  {
    path: "/productDetail",
    name: "productDetail",
    component: productDetail,
  },
  {
    path: "/productCustomize",
    name: "productCustomize",
    component: productCustomize,
  },
  {
    path: "/customizeList",
    name: "customizeList",
    component: customizeList,
  },
  {
    path: "/demandDetails",
    name: "demandDetails",
    component: demandDetails,
  },
];

const initRoutes = async () => {
  try {
    // 获取当前国家
    let countryRes = await request({
      method: "get",
      url: "/gci/getCountry",
    });
    let country =
      countryRes && countryRes.data && countryRes.data.country
        ? countryRes.data.country
        : null;
    country = country ? country.toUpperCase() : null;
    routes = routesAddArea(routes, country);
  } catch (error) {
    console.error("Error occurred while defining routes:", error);
    // 可以根据错误情况进行一些回退操作，比如显示错误页面或者重新尝试
  }
};

// 工厂函数，用于创建并返回Router实例
const createRouter = async () => {
  await initRoutes();
  return new Router({
    mode: "history",
    routes: routes,
  });
};

// 导出工厂函数
export default createRouter;
